import React, { Component } from "react";































import {































  Button,































  Container,































  Row, Form,































  Col,































  Offcanvas,































} from "react-bootstrap";































import { toast } from "react-toastify";































import DataTable from "react-data-table-component";































import configData from '../config.json';































import { ValidationUtils } from '../Sidebar/Common';































































import LoadingOverlay from "./LoadingOverlay";
export default class Role_permissions extends Component {































  constructor(props) {































    super(props);































    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",































      show: false,































      data: [],































      sId: sessionStorage.getItem("sessionId"),































      uId: sessionStorage.getItem("uId"),































      errors: {},































      touched: {}, // Track which fields have been touched































      filteredData: null,































      tableClms: [































        {































          name: "S.NO",































          selector: (row, i) => row.role_permissions_Id,































          sortable: true,































          cell: (row) => <span>{row.role_permissions_Id}</span>,































        },































        { name: "R Id", selector: (row, i) => row.rid, sortable: true, cell: (row) => <span>{row.rid}</span>, }, { name: "Module Name", selector: (row, i) => row.module_name, sortable: true, cell: (row) => <span>{row.module_name}</span>, }, { name: "Resource Name", selector: (row, i) => row.resource_name, sortable: true, cell: (row) => <span>{row.resource_name}</span>, }, { name: "Permission Type", selector: (row, i) => row.permission_type, sortable: true, cell: (row) => <span>{row.permission_type}</span>, }, { name: "Access Scope", selector: (row, i) => row.access_scope, sortable: true, cell: (row) => <span>{row.access_scope}</span>, }, { name: "Conditions", selector: (row, i) => row.conditions, sortable: true, cell: (row) => <span>{row.conditions}</span>, }, { name: "Is Active", selector: (row, i) => row.is_active, sortable: true, cell: (row) => <span>{row.is_active}</span>, }, { name: "Status", selector: (row, i) => row.status, sortable: true, cell: (row) => <span>{row.status}</span>, },































        { name: "Role Id", selector: (row, i) => row.role_id, sortable: true, cell: (row) => <span>{row.role_id}</span>, }, { name: "Permission Key", selector: (row, i) => row.permission_key, sortable: true, cell: (row) => <span>{row.permission_key}</span>, }, { name: "Permission Value", selector: (row, i) => row.permission_value, sortable: true, cell: (row) => <span>{row.permission_value}</span>, }, { name: "Resource Type", selector: (row, i) => row.resource_type, sortable: true, cell: (row) => <span>{row.resource_type}</span>, }, { name: "Operations", selector: (row, i) => row.operations, sortable: true, cell: (row) => <span>{row.operations}</span>, },//***tableClms































        {































          name: "Actions",































          sortable: false,































          cell: (row) => (































            <div>































              {/* edit button and delete button */}































              <Button































                style={{ marginRight: "10px" }}































                variant="primary"































                onClick={() => this.Role_permissionseditHandler(row)}































                className="bi bi-pen"































              >































              </Button>































              <Button































                variant="danger"































                onClick={() => this.handleDelete(row)}































                className="bi bi-trash danger"































              >































              </Button>































            </div>































          ),































        },































      ],































      currentPage: 1,































      itemsPerPage: 10,































      isEditing: false,































      role_permissions_Id: "",































      rid: '', module_name: '', resource_name: '', permissiontypemaster: [], permission_type: '', accessscopetypemaster: [], access_scope: '', conditions: '', is_active: '', statustypemaster: [], status: '',































      role_id: '', permission_key: '', permission_value: '', resource_type: '', operations: '',//***state































    };































  }































































  // Enhanced validation method using Common.js with auto-generated logic































  validateField = (fieldName, value, fieldConfig) => {































    const { inputType, validationOptions } = fieldConfig;































    const fieldDisplayName = fieldConfig.displayName || fieldName;































































    let validationResult = { isValid: true, message: "" };































































    // Auto-generated validation based on inputType and validationOptions































    switch (inputType.toLowerCase()) {































      case 'text':































        if (validationOptions?.isName) {































          validationResult = ValidationUtils.validateName(value);































        } else if (validationOptions?.isAddress) {































          validationResult = ValidationUtils.validateAddress(value);































        } else if (validationOptions?.maxLength) {































          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);































        } else {































          validationResult = { isValid: true, message: "" };































        }































        break;































































      case 'mail':































      case 'email':































        validationResult = ValidationUtils.validateEmail(value);































        break;































































      case 'telephone':































      case 'phone':































        validationResult = ValidationUtils.validatePhone(value);































        break;































































      case 'number':































        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);































        break;































































      case 'dob_child':































        validationResult = ValidationUtils.validateDOBMinAge(value);































        break;































































      case 'dob_adult':































        validationResult = ValidationUtils.validateDOBAdult(value);































        break;































































      case 'pan':































        validationResult = ValidationUtils.validatePAN(value);































        break;































































      case 'aadhaar':































        validationResult = ValidationUtils.validateAadhaar(value);































        break;































































      case 'password':































        if (value.length < 6) {































          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };































        }































        break;































































      default:































        validationResult = { isValid: true, message: "" };































    }































































    // Check required field validation































    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {































      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);































    }































































    const errors = { ...this.state.errors };































    if (!validationResult.isValid) {































      errors[fieldName] = validationResult.message;































    } else {































      delete errors[fieldName];































    }































































    this.setState({ errors });































    return validationResult.isValid;































  };































































  // Enhanced field change handler with auto-validation































  handleFieldChange = (fieldName, value, fieldConfig) => {































    this.setState({































      [fieldName]: value,































      touched: { ...this.state.touched, [fieldName]: true }































    });































































    // Only validate if field has been touched































    if (this.state.touched[fieldName] || value !== "") {































      this.validateField(fieldName, value, fieldConfig);































    }































  };































































  // Enhanced field blur handler for validation































  handleFieldBlur = (fieldName, value, fieldConfig) => {































    this.setState({































      touched: { ...this.state.touched, [fieldName]: true }































    });































    this.validateField(fieldName, value, fieldConfig);































  };































































  // Check if form is valid - auto-generated based on required fields































  isFormValid = () => {































    const { errors } = this.state;































































    // Auto-generated required field validation































    // No required fields defined































































































    return Object.keys(errors).length === 0;































  };































































  // Auto-generated validation for all fields before submission































  validateAllFields = () => {































    const fieldConfigs = [































      { fieldName: 'rid', inputType: 'Number', displayName: 'R Id', validationOptions: { isRequired: false } },































      { fieldName: 'module_name', inputType: 'Text', displayName: 'Module Name', validationOptions: { isRequired: false } },































      { fieldName: 'resource_name', inputType: 'Text', displayName: 'Resource Name', validationOptions: { isRequired: false } },































      { fieldName: 'permission_type', inputType: 'Select', displayName: 'Permission Type', validationOptions: { isRequired: false } },































      { fieldName: 'access_scope', inputType: 'Select', displayName: 'Access Scope', validationOptions: { isRequired: false } },































      { fieldName: 'conditions', inputType: 'Text', displayName: 'Conditions', validationOptions: { isRequired: false } },































      { fieldName: 'is_active', inputType: 'Number', displayName: 'Is Active', validationOptions: { isRequired: false } },































      { fieldName: 'status', inputType: 'Select', displayName: 'Status', validationOptions: { isRequired: false } }































    ];































































    fieldConfigs.forEach(config => {































      const value = this.state[config.fieldName];































      this.validateField(config.fieldName, value, config);































    });































































    const touched = {};































    fieldConfigs.forEach(config => {































      touched[config.fieldName] = true;































    });































    this.setState({ touched });































































  };































































  // offcanvas Open































  handleOffcanvasShow = () => {































    this.setState({































      show: true,































      errors: {},































      touched: {},































      rid: '', module_name: '', resource_name: '', permissiontypemaster: [], permission_type: '', accessscopetypemaster: [], access_scope: '', conditions: '', is_active: '', statustypemaster: [], status: '',































    });































  };































































  // Offcanvas close button































  handleOffcanvasClose = () => {































    this.setState({































      show: false,































      isEditing: false,































      errors: {},































      touched: {},































      rid: '', module_name: '', resource_name: '', permissiontypemaster: [], permission_type: '', accessscopetypemaster: [], access_scope: '', conditions: '', is_active: '', statustypemaster: [], status: '',































    });































  };































































  // Enhanced toast notifications































  showToast = (msg, type) => {































    switch (type) {































      case "success":































        toast.success(msg);































        break;































      case "error":































        toast.error(msg);































        break;































      case "warning":































        toast.warn(msg);































        break;































      default:































        toast.info(msg);































    }































  };































































  Role_permissionseditHandler = (row) => {































    this.setState({































      isEditing: true,































      show: true,































      role_permissions_Id: row.role_permissions_Id,































      rid: row.rid, module_name: row.module_name, resource_name: row.resource_name, permissiontypemaster: [], permission_type: row.permission_type, accessscopetypemaster: [], access_scope: row.access_scope, conditions: row.conditions, is_active: row.is_active, statustypemaster: [], status: row.status,































      role_id: row.role_id, permission_key: row.permission_key, permission_value: row.permission_value, resource_type: row.resource_type, operations: row.operations,//***editstate































      errors: {},































      touched: {}































    });































  }































































  Role_permissionsfetchHandler = () => {































    var formData = new FormData();































    formData.append("sId", this.state.sId);































    formData.append("uId", this.state.uId);































































    fetch(configData.api_url + 'C_Role_permissions/list', {































      method: 'POST',































      mode: 'cors',































      body: formData































    })































      .then(response => response.json())































      .then((data) => {































        if (data.status === "success") {































          this.setState({ data: data.list });































        }































      })































      .catch((error) => {































        console.error("Fetch error:", error);































        this.showToast("Failed to load data", "error");































      });































  }































































  Role_permissionssubmitHandler = (e) => {































    e.preventDefault();































































    // Validate all fields before submission































    this.validateAllFields();































































    if (!this.isFormValid()) {































      this.showToast("Please fix all errors before submitting", "error");































      return;































    }































































    var formData = new FormData();































    formData.append("sId", this.state.sId);































    formData.append("uId", this.state.uId);































    formData.append('rid', this.state.rid);































    formData.append('module_name', this.state.module_name);































    formData.append('resource_name', this.state.resource_name);































    formData.append('permission_type', this.state.permission_type);































    formData.append('access_scope', this.state.access_scope);































    formData.append('conditions', this.state.conditions);































    formData.append('is_active', this.state.is_active);































    formData.append('status', this.state.status);































































    formData.append('role_id', this.state.role_id);















    formData.append('permission_key', this.state.permission_key);







    formData.append('permission_value', this.state.permission_value);



    formData.append('resource_type', this.state.resource_type);

    formData.append('operations', this.state.operations);
    //***tableData*































































    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Role_permissions/add', {































      method: 'POST',































      mode: 'cors',































      body: formData































    })































      .then(response => response.json())































      .then((data) => {































        this.showToast(data.message, data.status);































        if (data.status === "success") {































          this.Role_permissionsfetchHandler();































          this.handleOffcanvasClose();































          this.setState({ rid: '', module_name: '', resource_name: '', permissiontypemaster: [], permission_type: '', accessscopetypemaster: [], access_scope: '', conditions: '', is_active: '', statustypemaster: [], status: '', });































        }































      
        this.setState({ loading: false });})































      .catch((error) => {































        console.error("Submit error:", error);































        this.showToast("Failed to save data", "error");































      
        this.setState({ loading: false });});































  }































































  Role_permissionsupdateHandler = (e) => {































    e.preventDefault();































































    // Validate all fields before submission































    this.validateAllFields();































































    if (!this.isFormValid()) {































      this.showToast("Please fix all errors before updating", "error");































      return;































    }































































    var formData = new FormData();































    formData.append("sId", this.state.sId);































    formData.append("uId", this.state.uId);































    formData.append("role_permissions_Id", this.state.role_permissions_Id);































    formData.append('rid', this.state.rid);































    formData.append('module_name', this.state.module_name);































    formData.append('resource_name', this.state.resource_name);































    formData.append('permission_type', this.state.permission_type);































    formData.append('access_scope', this.state.access_scope);































    formData.append('conditions', this.state.conditions);































    formData.append('is_active', this.state.is_active);































    formData.append('status', this.state.status);































































    formData.append('role_id', this.state.role_id);















    formData.append('permission_key', this.state.permission_key);







    formData.append('permission_value', this.state.permission_value);



    formData.append('resource_type', this.state.resource_type);

    formData.append('operations', this.state.operations);
    //***tableData1































































    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Role_permissions/update', {































      method: 'POST',































      mode: 'cors',































      body: formData































    })































      .then(response => response.json())































      .then((data) => {































        this.showToast(data.message, data.status);































        if (data.status === "success") {































          this.Role_permissionsfetchHandler();































          this.handleOffcanvasClose();































        }































      
        this.setState({ loading: false });})































      .catch((error) => {































        console.error("Update error:", error);































        this.showToast("Failed to update data", "error");































      
        this.setState({ loading: false });});































  }































































  componentDidMount() {































    this.Role_permissionsfetchHandler();































    this.permissiontypemasterfetchHandler();































    this.accessscopetypemasterfetchHandler();































    this.statustypemasterfetchHandler();































































    //***componentDidMount































  }































































  handleridChange = (e) => {































    e.preventDefault();































    const fieldValue = e.target.value;































    this.setState({ rid: fieldValue });































  }; handlemodule_nameChange = (e) => {































    e.preventDefault();































    const fieldValue = e.target.value;































    this.setState({ module_name: fieldValue });































  }; handleresource_nameChange = (e) => {































    e.preventDefault();































    const fieldValue = e.target.value;































    this.setState({ resource_name: fieldValue });































  }; handlepermission_typeChange = (e) => {































    e.preventDefault();































































    const fieldValue = e.target.value;































    this.setState({ permission_type: fieldValue });































  }; permissiontypemasterfetchHandler = () => {































    fetch(configData.api_url + "C_Permissiontypemaster/list", {  // Enter your IP address here































      method: "POST",































      mode: "cors",































      body: {}// body data type must match "Content-Type" header































    }).then(response => response.json())































      .then((data) => {































        if (data.status === "success") {































          this.setState({ permissiontypemaster: data.list });































        }































      });































  }; handleaccess_scopeChange = (e) => {































    e.preventDefault();































































    const fieldValue = e.target.value;































    this.setState({ access_scope: fieldValue });































  }; accessscopetypemasterfetchHandler = () => {































    fetch(configData.api_url + "C_Accessscopetypemaster/list", {  // Enter your IP address here































      method: "POST",































      mode: "cors",































      body: {}// body data type must match "Content-Type" header































    }).then(response => response.json())































      .then((data) => {































        if (data.status === "success") {































          this.setState({ accessscopetypemaster: data.list });































        }































      });































  }; handleconditionsChange = (e) => {































    e.preventDefault();































    const fieldValue = e.target.value;































    this.setState({ conditions: fieldValue });































  }; handleis_activeChange = (e) => {































    e.preventDefault();































    const fieldValue = e.target.value;































    this.setState({ is_active: fieldValue });































  }; handlestatusChange = (e) => {































    e.preventDefault();































































    const fieldValue = e.target.value;































    this.setState({ status: fieldValue });































  }; statustypemasterfetchHandler = () => {































    fetch(configData.api_url + "C_Statustypemaster/list", {  // Enter your IP address here































      method: "POST",































      mode: "cors",































      body: {}// body data type must match "Content-Type" header































    }).then(response => response.json())































      .then((data) => {































        if (data.status === "success") {































          this.setState({ statustypemaster: data.list });































        }































      });































  };































  handlerole_idChange = (e) => {















    e.preventDefault();















    const fieldValue = e.target.value;















    this.setState({ role_id: fieldValue });















  }; handlepermission_keyChange = (e) => {







    e.preventDefault();







    const fieldValue = e.target.value;







    this.setState({ permission_key: fieldValue });







  }; handlepermission_valueChange = (e) => {



    e.preventDefault();



    const fieldValue = e.target.value;



    this.setState({ permission_value: fieldValue });



  }; handleresource_typeChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ resource_type: fieldValue });

  }; handleoperationsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ operations: fieldValue });
  };//***inputFunctions































































  handleRowSelect = (row) => {































    this.setState({































      selectedRow: row.index,































    });































  };































































  handleRowUpdate = (newData, oldData) => {































    const data = [...this.state.data];































    const index = oldData.index;































    data[index] = newData;































    this.setState({ data });































  };































































  handleEdit = (row) => {































    console.log(`Editing row with ID ${row.id}`);































  };































































  handleDelete = (row, index) => {































    if (!window.confirm(`Are you sure you want to delete this role_permissions?`)) {































      return;































    }































































    var formData = new FormData();































    formData.append('role_permissions_Id', row.role_permissions_Id);































































    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Role_permissions/delete', {































      method: 'POST',































      mode: 'cors',































      body: formData































    })































      .then(response => response.json())































      .then((data) => {































        this.showToast(data.message, data.status);































        if (data.status === "success") {































          this.Role_permissionsfetchHandler();































        }































      
        this.setState({ loading: false });})































      .catch((error) => {































        console.error("Delete error:", error);































        this.showToast("Failed to delete data", "error");































      
        this.setState({ loading: false });});































  };































































  handlePageChange = (page) => {































    this.setState({ currentPage: page });































  };































































  handlePerRowsChange = (newPerPage, page) => {































    this.setState({ itemsPerPage: newPerPage, currentPage: page });































  };































































  handleFilter = (e) => {































    const searchValue = e.target.value.toLowerCase();































    const filteredData = this.state.data.filter((row) => {































      return Object.values(row).join(" ").toLowerCase().includes(searchValue);































    });































    this.setState({ filteredData });































  };































































  // Helper method to render error message































  renderFieldError = (fieldName) => {































    const { errors, touched } = this.state;































    if (errors[fieldName] && touched[fieldName]) {































      return (































        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>































          <i className="bi bi-exclamation-circle me-1"></i>































          {errors[fieldName]}































        </div>































      );































    }































    return null;































  };































































  // Auto-generated form field renderer based on inputType and validation options































  renderFormField = (fieldConfig) => {































    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;































    const value = this.state[fieldName] || "";































    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];































































    let inputElement;































































    switch (inputType.toLowerCase()) {































      case 'dob_child':































      case 'dob_adult':































      case 'date':































        inputElement = (































          <Form.Control































            type="date"































            value={value}































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































            isInvalid={hasError}































            required={validationOptions?.isRequired}































          />































        );































        break;































































      case 'telephone':































      case 'phone':































        inputElement = (































          <Form.Control































            type="tel"































            value={value}































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































            isInvalid={hasError}































            required={validationOptions?.isRequired}































            placeholder="Enter 10-digit mobile number"































          />































        );































        break;































































      case 'mail':































      case 'email':































        inputElement = (































          <Form.Control































            type="email"































            value={value}































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































            isInvalid={hasError}































            required={validationOptions?.isRequired}































            placeholder="Enter email address"































          />































        );































        break;































































      case 'password':































        inputElement = (































          <Form.Control































            type="password"































            value={value}































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































            isInvalid={hasError}































            required={validationOptions?.isRequired}































            placeholder="Enter password"































          />































        );































        break;































































      case 'number':































        inputElement = (































          <Form.Control































            type="number"































            value={value}































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































            isInvalid={hasError}































            required={validationOptions?.isRequired}































            placeholder={`Enter ${displayName.toLowerCase()}`}































          />































        );































        break;































































      case 'pan':































        inputElement = (































          <Form.Control































            type="text"































            value={value}































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































            isInvalid={hasError}































            required={validationOptions?.isRequired}































            placeholder="ABCPA1234B"































            maxLength="10"































          />































        );































        break;































































      case 'aadhaar':































        inputElement = (































          <Form.Control































            type="text"































            value={value}































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































            isInvalid={hasError}































            required={validationOptions?.isRequired}































            placeholder="123456789012"































            maxLength="12"































          />































        );































        break;































































      default: // text and other types































        inputElement = (































          <Form.Control































            type="text"































            value={value}































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































            isInvalid={hasError}































            required={validationOptions?.isRequired}































            placeholder={`Enter ${displayName.toLowerCase()}`}































            maxLength={validationOptions?.maxLength || undefined}































          />































        );































    }































































    return (































      <Row key={fieldName}>































        <Col lg="4" md="4">































          <Form.Label>































            {displayName}































            {validationOptions?.isRequired && <span className="text-danger">*</span>}































          </Form.Label>































        </Col>































        <Col lg="8" md="8">































          {inputElement}































          {this.renderFieldError(fieldName)}































        </Col>































      </Row>































    );































  };































































  render() {































    const { errors, touched } = this.state;































































    const paginatedData = this.state.filteredData































      ? this.state.filteredData.slice(































        (this.state.currentPage - 1) * this.state.itemsPerPage,































        this.state.currentPage * this.state.itemsPerPage































      )































      : this.state.data.slice(































        (this.state.currentPage - 1) * this.state.itemsPerPage,































        this.state.currentPage * this.state.itemsPerPage































      );































































    return (































      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />































        <div className="row">































          <div className="col-md-12 col-sm-12 col-xs-12">































            <div className="x_panel">































              <div className="x_content">































                <div































                  id="datatable_wrapper"































                  className="dataTables_wrapper form-inline































                dt-bootstrap no-footer"































                >































                  <Row className="row">































                    <div>































                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Role Permissions</h3>































                    </div>































                    <Col































                      className="d-flex justify-content-end"































                      style={{ marginRight: "5px", marginTop: "20px" }}































                    >































                      <Button































                        variant="primary" style={{ float: "right", marginBottom: "10px" }}































                        className="bi bi-plus "































                        onClick={this.handleOffcanvasShow}































                      >































                        New































                      </Button>































































                      {/* Enhanced Add Offcanvas */}































                      <Offcanvas































                        show={this.state.show && !this.state.isEditing}































                        onHide={this.handleOffcanvasClose}































                        {...this.props}































                        style={{ width: "500px" }}































                        placement="end"































                        backdrop="true"































                      >































                        <Offcanvas.Header closeButton>































                          <Offcanvas.Title>Add Role_permissions</Offcanvas.Title>































                        </Offcanvas.Header>































                        <Offcanvas.Body>































                          <Container style={{ "overflowY": "auto", height: "auto" }}>































































                            {/* Error Summary */}































                            {Object.keys(errors).length > 0 && (































                              <div className="alert alert-danger mb-3">































                                <strong>Please fix the following errors:</strong>































                                <ul className="mb-0 mt-2">































                                  {Object.entries(errors).map(([field, error]) => (































                                    <li key={field}>{error}</li>































                                  ))}































                                </ul>































                              </div>































                            )}































































                            <Row className="divstyle">































                              <Row>































                                <Form>































                                  <Row>































                                    <Col lg="4" md="4">































                                      <Form.Label style={{ paddingTop: "8px" }}>R Id</Form.Label>































                                    </Col>































                                    <Col lg="8" md="8">































                                      <Form.Control type="number" onChange={this.handleridChange} className="form-control" name="rid" value={this.state.rid} required="required" placeholder="Enter R Id" />































                                    </Col>































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.rid} </div>































                                  </Row><br /><Row>































                                    <Col lg="4" md="4">































                                      <Form.Label style={{ paddingTop: "8px" }}>Module Name</Form.Label>































                                    </Col>































                                    <Col lg="8" md="8">































                                      <Form.Control type="text" onChange={this.handlemodule_nameChange} className="form-control" name="module_name" value={this.state.module_name} required="required" placeholder="Enter Module Name" />































                                    </Col>































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.module_name} </div>































                                  </Row><br /><Row>































                                    <Col lg="4" md="4">































                                      <Form.Label style={{ paddingTop: "8px" }}>Resource Name</Form.Label>































                                    </Col>































                                    <Col lg="8" md="8">































                                      <Form.Control type="text" onChange={this.handleresource_nameChange} className="form-control" name="resource_name" value={this.state.resource_name} required="required" placeholder="Enter Resource Name" />































                                    </Col>































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resource_name} </div>































                                  </Row><br /><Row>































                                    <Col lg="4" md="4">































                                      <Form.Label style={{ paddingTop: "8px" }}>Permission Type</Form.Label>































                                    </Col>































                                    <Col lg="8" md="8">































                                      <select className="form-select" name="tableName" onChange={this.handlepermission_typeChange}>































                                        <option defaultValue> Select Permission Type </option>































                                        {this.state.permissiontypemaster.map((api, index, idx) => (































                                          <option key={index} value={api.view}> {api.view} </option>































                                        ))}































                                      </select>































                                    </Col>































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.permission_type} </div>































                                  </Row><br /><Row>































                                    <Col lg="4" md="4">































                                      <Form.Label style={{ paddingTop: "8px" }}>Access Scope</Form.Label>































                                    </Col>































                                    <Col lg="8" md="8">































                                      <select className="form-select" name="tableName" onChange={this.handleaccess_scopeChange}>































                                        <option defaultValue> Select Access Scope </option>































                                        {this.state.accessscopetypemaster.map((api, index, idx) => (































                                          <option key={index} value={api.none}> {api.none} </option>































                                        ))}































                                      </select>































                                    </Col>































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.access_scope} </div>































                                  </Row><br /><Row>































                                    <Col lg="4" md="4">































                                      <Form.Label style={{ paddingTop: "8px" }}>Conditions</Form.Label>































                                    </Col>































                                    <Col lg="8" md="8">































                                      <Form.Control type="text" onChange={this.handleconditionsChange} className="form-control" name="conditions" value={this.state.conditions} required="required" placeholder="Enter Conditions" />































                                    </Col>































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.conditions} </div>































                                  </Row><br /><Row>































                                    <Col lg="4" md="4">































                                      <Form.Label style={{ paddingTop: "8px" }}>Is Active</Form.Label>































                                    </Col>































                                    <Col lg="8" md="8">































                                      <Form.Control type="number" onChange={this.handleis_activeChange} className="form-control" name="is_active" value={this.state.is_active} required="required" placeholder="Enter Is Active" />































                                    </Col>































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.is_active} </div>































                                  </Row><br /><Row>































                                    <Col lg="4" md="4">































                                      <Form.Label style={{ paddingTop: "8px" }}>Status</Form.Label>































                                    </Col>































                                    <Col lg="8" md="8">































                                      <select className="form-select" name="tableName" onChange={this.handlestatusChange}>































                                        <option defaultValue> Select Status </option>































                                        {this.state.statustypemaster.map((api, index, idx) => (































                                          <option key={index} value={api.active}> {api.active} </option>































                                        ))}































                                      </select>































                                    </Col>































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.status} </div>































                                  </Row><br />































                                  {/* Auto-generated form content with validation */}































                                </Form>































                              </Row>































                            </Row>































                            <Row>































                              <Col































                                className="d-flex justify-content-end"































                                style={{ marginRight: "50px" }}































                              >































                                <Button































                                  className="button"































                                  variant="success"































                                  onClick={this.Role_permissionssubmitHandler}































                                  disabled={!this.isFormValid()}































                                  style={{































                                    marginTop: "20px",































                                  }}































                                >































                                  Save































                                </Button>































                              </Col>































                            </Row>































                          </Container>































                        </Offcanvas.Body>































                      </Offcanvas>































































                      {/* Enhanced Edit Offcanvas */}































                      {this.state.isEditing && (































                        <Offcanvas































                          show={this.state.isEditing}































                          onHide={this.handleOffcanvasClose}































                          {...this.props}































                          style={{ width: "500px" }}































                          placement="end"































                          backdrop="true"































                        >































                          <Offcanvas.Header closeButton>































                            <Offcanvas.Title>Edit Role_permissions</Offcanvas.Title>































                          </Offcanvas.Header>































                          <Offcanvas.Body>































                            <Container style={{ "overflowY": "auto", height: "auto" }}>































































                              {/* Error Summary */}































                              {Object.keys(errors).length > 0 && (































                                <div className="alert alert-danger mb-3">































                                  <strong>Please fix the following errors:</strong>































                                  <ul className="mb-0 mt-2">































                                    {Object.entries(errors).map(([field, error]) => (































                                      <li key={field}>{error}</li>































                                    ))}































                                  </ul>































                                </div>































                              )}































































                              <Row className="divstyle">































                                <Row>































                                  <Form>































                                    <Row>































                                      <Col lg="4" md="4">































                                        <Form.Label style={{ paddingTop: "8px" }}>R Id</Form.Label>































                                      </Col>































                                      <Col lg="8" md="8">































                                        <Form.Control type="number" onChange={this.handleridChange} className="form-control" name="rid" value={this.state.rid} required="required" placeholder="Enter R Id" />































                                      </Col>































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.rid} </div>































                                    </Row><br /><Row>































                                      <Col lg="4" md="4">































                                        <Form.Label style={{ paddingTop: "8px" }}>Module Name</Form.Label>































                                      </Col>































                                      <Col lg="8" md="8">































                                        <Form.Control type="text" onChange={this.handlemodule_nameChange} className="form-control" name="module_name" value={this.state.module_name} required="required" placeholder="Enter Module Name" />































                                      </Col>































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.module_name} </div>































                                    </Row><br /><Row>































                                      <Col lg="4" md="4">































                                        <Form.Label style={{ paddingTop: "8px" }}>Resource Name</Form.Label>































                                      </Col>































                                      <Col lg="8" md="8">































                                        <Form.Control type="text" onChange={this.handleresource_nameChange} className="form-control" name="resource_name" value={this.state.resource_name} required="required" placeholder="Enter Resource Name" />































                                      </Col>































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resource_name} </div>































                                    </Row><br /><Row>































                                      <Col lg="4" md="4">































                                        <Form.Label style={{ paddingTop: "8px" }}>Permission Type</Form.Label>































                                      </Col>































                                      <Col lg="8" md="8">































                                        <select className="form-select" name="tableName" onChange={this.handlepermission_typeChange}>































                                          <option defaultValue> Select Permission Type </option>































                                          {this.state.permissiontypemaster.map((api, index, idx) => (































                                            <option key={index} value={api.view}> {api.view} </option>































                                          ))}































                                        </select>































                                      </Col>































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.permission_type} </div>































                                    </Row><br /><Row>































                                      <Col lg="4" md="4">































                                        <Form.Label style={{ paddingTop: "8px" }}>Access Scope</Form.Label>































                                      </Col>































                                      <Col lg="8" md="8">































                                        <select className="form-select" name="tableName" onChange={this.handleaccess_scopeChange}>































                                          <option defaultValue> Select Access Scope </option>































                                          {this.state.accessscopetypemaster.map((api, index, idx) => (































                                            <option key={index} value={api.none}> {api.none} </option>































                                          ))}































                                        </select>































                                      </Col>































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.access_scope} </div>































                                    </Row><br /><Row>































                                      <Col lg="4" md="4">































                                        <Form.Label style={{ paddingTop: "8px" }}>Conditions</Form.Label>































                                      </Col>































                                      <Col lg="8" md="8">































                                        <Form.Control type="text" onChange={this.handleconditionsChange} className="form-control" name="conditions" value={this.state.conditions} required="required" placeholder="Enter Conditions" />































                                      </Col>































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.conditions} </div>































                                    </Row><br /><Row>































                                      <Col lg="4" md="4">































                                        <Form.Label style={{ paddingTop: "8px" }}>Is Active</Form.Label>































                                      </Col>































                                      <Col lg="8" md="8">































                                        <Form.Control type="number" onChange={this.handleis_activeChange} className="form-control" name="is_active" value={this.state.is_active} required="required" placeholder="Enter Is Active" />































                                      </Col>































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.is_active} </div>































                                    </Row><br /><Row>































                                      <Col lg="4" md="4">































                                        <Form.Label style={{ paddingTop: "8px" }}>Status</Form.Label>































                                      </Col>































                                      <Col lg="8" md="8">































                                        <select className="form-select" name="tableName" onChange={this.handlestatusChange}>































                                          <option defaultValue> Select Status </option>































                                          {this.state.statustypemaster.map((api, index, idx) => (































                                            <option key={index} value={api.active}> {api.active} </option>































                                          ))}































                                        </select>































                                      </Col>































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.status} </div>































                                    </Row><br />































                                    {/* Auto-generated form content with validation */}































                                  </Form>































                                </Row>































                              </Row>































                              <Row>































                                <Col































                                  className="d-flex justify-content-end"































                                  style={{ marginRight: "50px" }}































                                >































                                  <Button































                                    className="button"































                                    variant="success"































                                    onClick={this.Role_permissionsupdateHandler}































                                    disabled={!this.isFormValid()}































                                    style={{































                                      marginTop: "20px",































                                    }}































                                  >































                                    Update































                                  </Button>































                                </Col>































                              </Row>































                            </Container>































                          </Offcanvas.Body>































                        </Offcanvas>































                      )}































                      {/*offcanvas is over */}































                    </Col>































                  </Row>































                  <br />































                  <Row>































                    <div style={{ "marginRight": "5px" }}>































                      {/* searchbar,pagination,filter */}































                      <input































                        type="text"































                        style={{ float: "left", marginBottom: "10px" }}































                        onChange={this.handleFilter}































                        placeholder="Search..."































                      />































                      <DataTable































                        data={paginatedData}































                        columns={this.state.tableClms}































                        pagination































                        paginationServer































                        paginationTotalRows={































                          this.state.filteredData































                            ? this.state.filteredData.length































                            : this.state.data.length































                        }































                        onChangeRowsPerPage={this.handlePerRowsChange}































                        onChangePage={this.handlePageChange}































                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}































                        keyField="id"































                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"































                      />































                    </div>































                  </Row>































































                </div>































              </div>































            </div>































          </div>































        </div>































      </div>































































    );































  }































}